import { theme } from "../../../utils/theme";

export const popoverPaperProps = {
  width: "332px",
  maxHeight: "390px",
  borderRadius: "12px",
  boxShadow: "0px 4px 20px #0000001A",
  mt: 1,
  overflow: "hidden",
};

export const gridContainerStyle = {
  p: 2,
};

export const moduleNavLinkStyle = {
  textDecoration: "none",
  color: "inherit",
  display: "block",
};

export const modulePaperStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  p: 1,
  maxWidth: "100px",
  maxHeight: "100px",
  width: "100%",
  height: "100%",
  borderRadius: "12px",
  boxShadow: "0px 2px 8px #0000000D",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    boxShadow: "0px 4px 12px #0000001A",
    transform: "translateY(-2px)",
  },
};

export const moduleIconBoxStyle = {
  width: 40,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 1,
  borderRadius: "12px",
  backgroundColor: "#EDF2F7",
};

export const moduleIconStyle = {
  width: "20px",
  height: "20px",
};

export const moduleTitleStyle = {
  textAlign: "center",
  fontSize: "12px",
  color: "#333333",
  fontWeight: 500,
  width: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const footerContainerStyle = {
  borderTop: "1px solid #E3ECEF",
  p: 1.5,
  textAlign: "center",
};

export const dashboardNavLinkStyle = {
  textDecoration: "none",
  display: "inline-block",
};

export const dashboardButtonStyle = {
  borderRadius: "6px",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 500,
  padding: "6px 16px",
  height: "34px",
  borderColor: "#C9CBCC",
  color: theme.palette.primary.main,
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    borderColor: theme.palette.primary.main,
    backgroundColor: "#0066CC0A",
    transform: "translateY(-1px)",
    boxShadow: "0px 2px 4px #0000001A",
  },
};
